enum ENVIRONMENT {
    DEVELOPMENT = 'development',
    MAINNET = 'mainnet',
    TESTNET = 'testnet',
    MAINNET_STAGING = 'mainnet_STAGING',
    TESTNET_STAGING = 'testnet_STAGING',
}

export default ENVIRONMENT;
